import { render, staticRenderFns } from "./RegisteredProductEdit.vue?vue&type=template&id=a2d5c6d6"
import script from "./RegisteredProductEdit.vue?vue&type=script&lang=js"
export * from "./RegisteredProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports